module.exports = __webpack_public_path__ + "img/mg.65482ca5.svg";